import './address.component.scss'
import 'holy-stars/index.css'

import HolyStars from 'holy-stars'

const starsPlaces = document.querySelectorAll('.address-stars__body')
starsPlaces.forEach(wrap => {
	const num = +wrap.textContent
	new HolyStars({
		el: wrap,
		rate: +num,
		size: 15,
		primaryColor: '#FBCE2F',
		secondColor: '#CDD3EB'
	})
})


const dropdownMenu = document.querySelectorAll('.address-list__item.dropdown')

if (dropdownMenu.length > 0) {
	dropdownMenu.forEach((item) => {
		item.addEventListener('click', (e) => {
			const content = item.querySelector('.address-list__content')

			if (e.target.classList.contains('main-part')) {
				item.classList.toggle('js-active')
				if (item.classList.contains('js-active')) {
					content.style.maxHeight = content.scrollHeight + 'px'
					item.style.setProperty('--dropdown-menu-height', item.clientHeight + content.scrollHeight - 20 + 'px')
				} else {
					content.style.maxHeight = 0
				}
			}
		})
	})
}
